import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CultureHero from './components/CultureHero';
import Innovation from './components/Innovation';
import Quality from './components/Quality';
import Collaboration from './components/Collaboration';
import Courage from './components/Courage';
import CultureCTA from './components/CultureCTA';

export default function CulturePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <CultureHero />
      <Innovation />
      <Quality />
      <Collaboration />
      <Courage />
      <CultureCTA />
      <Footer />
    </div>
  );
}
